import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IConfigurationResponse, ISearchMidwifeBody, IService } from 'src/app/models/dashboard.models';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss']
})
export class SearchFiltersComponent implements OnInit {

  searchParam: ISearchMidwifeBody;
  displayFilter: boolean = false;
  clearBtn: boolean;
  filterMessage: string = 'More Filters'
  ethnicities: Array<string> = [];
  specialities: Array<string> = [];
  @Output() searchOption = new EventEmitter();
  @Output() clear = new EventEmitter();
  areas: IService[] = [];
  subAreas: IService[] = [];
  selectedArea: string;

  constructor(public homeService: HomeService) { 
    this.getDropdownConfigurations();
  }

  ngOnInit(): void {
    this.clearBtn = false;
    this.searchParam = {
      minimumExperience: "0",
      ethnicity: "All",
      speciality: "All",
      sortingCriteria: "A_Z_ASC",
      serviceArea: "All",
      midwifeName: "",
      offset: 0,
      limit: 15
    };
    this.selectedArea = 'All';
    this.searchParam.serviceArea = 'All';
    this.subAreas = [];
  }

  toggleFilter(){
    if(this.displayFilter)
    {
      this.filterMessage = 'More filters';
      this.displayFilter = false;
    }else{
      this.filterMessage = 'Hide filters';
      this.displayFilter = true;
    }
  }

  searchMidwife(){
    this.clearBtn = true;
    if(this.displayFilter){
      this.searchOption.emit(this.searchParam);
    }
    else{
      let searchBody: ISearchMidwifeBody = {
        sortingCriteria: this.searchParam.sortingCriteria,
        midwifeName: this.searchParam.midwifeName,
        serviceArea: this.searchParam.serviceArea,
        offset: 0,
        limit: 15
      }
      this.searchOption.emit(searchBody);
    }
  }

  reset(){
    this.ngOnInit();
    this.clear.emit();
  }

  getDropdownConfigurations(){
    this.ethnicities = [];
    this.specialities = [];
    this.areas = [];
    this.subAreas = [];
    this.homeService.getMiscConfiguration()
    .subscribe((res: IConfigurationResponse)=>{
      res.payload.ethnicities.forEach(ethnicitie => this.ethnicities.push(ethnicitie.name));
      res.payload.specialities.forEach(specialitie => this.specialities.push(specialitie.name));
      this.areas = res.payload.serviceAreas;
    },err=>{
      console.error("Dropdown Error:", err);
    });
  }

  getSubAreas(){
    if(this.selectedArea == 'All')
    {
      this.searchParam.serviceArea = 'All';
      this.subAreas = [];
      this.searchMidwife();
    }
    else{
      this.areas.forEach(area=>{
        if(area.id == Number(this.selectedArea))
        {
          this.subAreas = area.childAreas;
        }
      });
    }
  }
}
